import { render, staticRenderFns } from "./UserPopup.vue?vue&type=template&id=050a7564&scoped=true"
import script from "./UserPopup.vue?vue&type=script&lang=js"
export * from "./UserPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050a7564",
  null
  
)

export default component.exports